<template>
<v-select
    :items="items"
    :label="label"
    item-text="label"
    item-value="rate_card_id"
    :value="value"
    v-on:change="onChange"
/>
</template>

<script>
export default {
    data() {
        return {
            items: []
        }
    },

    props: {
        label: {
            type: String,
            default: function() { return "Rate Card"; }
        },
        value: {
            type: String,
            default: function() { return null; }
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            
            this.$rc.listBuiltInRateCards(
                (data) => {
                    this.items = data.results;
                },
            
                () => {
                    
                },
            );
        },

        onChange(rate_card_id)
        {
            this.$emit('input', rate_card_id);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>